module.exports = __webpack_public_path__ + "img/6.f4fc0356.png";